import { SvgIconTypeMap } from "@mui/material";
import { colors } from "../data/colors";
import { OverridableComponent } from "@mui/material/OverridableComponent";

export default function BasicButton({
  type = "",
  title = "",
  color = colors.darkBlue,
  onClick = () => {},
  style = {},
  Icon = null,
  LastIcon = null,
  popup,
}: {
  type?: string;
  title?: string;
  onClick: () => void;
  color?: string;
  style?: object;
  Icon?: OverridableComponent<SvgIconTypeMap<{}, "svg">> | null;
  LastIcon?: OverridableComponent<SvgIconTypeMap<{}, "svg">> | null;
  popup?: string;
}) {
  return (
    <button
      title={popup}
      className={`stdButton noSelect${type === "mini" ? " miniButton" : ""}`}
      style={{
        backgroundColor: color,
        display: "flex",
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
        justifyItems: "center",
        ...style,
      }}
      onClick={onClick}
    >
      {Icon && (
        <Icon
          style={{
            fontSize: 20,
            marginRight: title !== "" ? 5 : 0,
          }}
        />
      )}
      {title}
      {LastIcon && (
        <LastIcon
          style={{
            fontSize: 20,
            marginLeft: title !== "" ? 5 : 0,
          }}
        />
      )}
    </button>
  );
}
